import { render, staticRenderFns } from "./OrderOnboarding.vue?vue&type=template&id=07a3e62a&scoped=true"
import script from "./OrderOnboarding.vue?vue&type=script&lang=js"
export * from "./OrderOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a3e62a",
  null
  
)

export default component.exports